import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { APP_ROUTES } from "./app.routes";
import { PagesModule } from "./pages/pages.module";

import { ServiceModule } from "./services/service.module";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./login/register.component";
import { FormsModule } from "@angular/forms";
import { ForgotpassComponent } from "./login/forgotpass/forgotpass.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenService } from "./interceptors/token.service";
import { ItemsModule } from "./pages/items/items.module";
import { SharedModule } from "./shared/shared.module";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule, StorageBucket } from "@angular/fire/storage";
import { environment } from "src/environments/environment";
import { AuthService } from "./services/authorization/auth.service";
import { TermsofuseComponent } from "./legal/termsofuse/termsofuse.component";
import { PrivacyPolicyComponent } from "./legal/privacy-policy/privacy-policy.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ForgotpassComponent,
    TermsofuseComponent,
    PrivacyPolicyComponent,
  ],
  imports: [
    BrowserModule,
    PagesModule,
    ServiceModule,
    SharedModule,
    ItemsModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule, // imports firebase/auth, only needed for auth feat
    AngularFireStorageModule,
    APP_ROUTES,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenService,
      multi: true,
    },
    {
      provide: StorageBucket,
      useValue: "winmoneykey.appspot.com",
    },
    AuthService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
